


























import {Component, Vue} from "vue-property-decorator";
import {EventBus} from "@common/EventBus";
import ChatView from "@service/views/ChatView.vue";

@Component({
    name: "InitError",
    components: {ChatView}
})
export default class InitError extends Vue {
    showChat = true;
    showEmail = false;

    get supportChat() {
        return this.$store.getters['services/getServiceParam']('supportChat', 'auth');
    }

    get supportIsAvailable() {
        return !!(this.supportChat || this.$store.state.services.freshChat);
    }

    get errorsList() {
        const errors = this.$store.state.initErrors || [];
        const errorsList: string[] = [];
        errors.forEach((item: any) => {
            if (typeof item == 'object' && item.response?.status == 403) {
                const neededRight =  item.response.data?.message ? this.getNeededRight(item.response.data?.message) : '';
                if (neededRight) {
                    errorsList.push(this.$t('init-errors.errors.needRight', {right: neededRight}).toString());
                }
            }
        });
        return [...new Set(errorsList)];
    }

    mounted() {
        if (!this.$store.state.services.freshChat) {
            this.showEmail = true;
        }
    }

    onConnect() {
        // EventBus.$emit('messageTo', 1);
        if (this.supportChat?.supporterUserId !== undefined) {
            EventBus.$emit('messageTo', this.supportChat.supporterUserId);
        }
        else {
            this.openFreshChat();
        }
    }

    openFreshChat() {
        const freshChat = this.$store.state.services.freshChat;
        if (freshChat) {
            freshChat.open();
        }
    }

    async onLogout() {
        await this.$store.dispatch('resetSession');
        this.$analytics.setGtagParams(false, true);
        await this.$router.push({name: 'Login', params: { backend: this.$route.params.backend, eventId: this.$route.params.eventId } });
        this.$store.commit('setInitErrors', []);
    }

    getNeededRight(message: string) {
        let regExp = /'([^)]+)'/;
        let matches = regExp.exec(message);

        return matches && matches.length > 0 ? matches[1] : '';
    }

    close() {
        return;
    }
}
